import { useEffect, useState } from "react";

export const useInfiniteScroll = (): [boolean, () => void] => {
  const [scrolledToBottom, setScrolledToBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const hasScrolledToBottom =
        window.innerHeight + Math.ceil(window.scrollY) >=
        document.body.scrollHeight;

      if (hasScrolledToBottom) setScrolledToBottom(true);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return [scrolledToBottom, () => setScrolledToBottom(false)];
};
